import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/app/DataTable";
import { useFetch } from "@/hooks/useFetch";
import { downloadFile, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

// Every file linked to the LM (LM, dispatches, movements, QC, Asset Group) plus generated Delivery Challans, in one list
export function LmAllDocuments({ orderId, tick }) {
  const { data } = useFetch(`/orders/${orderId}/all-documents?t=${tick || 0}`);
  const [src, setSrc] = useState("all");
  const sources = useMemo(() => [...new Set((data || []).map((d) => d.source.split(" ")[0]))], [data]);
  const rows = useMemo(() => (data || []).filter((d) => src === "all" || d.source.startsWith(src)), [data, src]);
  const cols = [
    { key: "doc_type", label: "Type" }, { key: "title", label: "File", value: (d) => d.title || d.stored_name, render: (d) => <span className="whitespace-normal">{d.title || d.stored_name}{d.generated && <span className="ml-1 text-[10px] text-slate-500">(generated)</span>}</span> },
    { key: "source", label: "From" }, { key: "uploaded_by", label: "By", value: (d) => d.uploaded_by?.name || "", render: (d) => d.uploaded_by?.name || "System" },
    { key: "uploaded_at", label: "Date", render: (d) => fmtDateTime(d.uploaded_at) },
    { key: "dl", label: "", exp: false, render: (d) => <Button variant="ghost" size="icon" onClick={(e) => { e.stopPropagation(); downloadFile(d.download_url, d.stored_name).catch((x) => toast.error(errMsg(x))); }} data-testid={`lm-all-doc-download-${d.id}`}><Download className="h-4 w-4" /></Button> },
  ];
  return (
    <section className="mt-6" data-testid="lm-all-documents">
      <div className="mb-2 flex flex-wrap items-center gap-2">
        <h3 className="text-sm font-semibold">All files for this LM ({data?.length || 0})</h3>
        {["all", ...sources].map((s) => <Button key={s} size="sm" variant={src === s ? "default" : "outline"} className="h-7" onClick={() => setSrc(s)} data-testid={`lm-all-docs-filter-${s}`}>{s === "all" ? "All" : s}</Button>)}
      </div>
      <p className="mb-2 text-[11px] text-slate-500">LR, POD, e-way bills, invoices, QC reports, dispatch and movement documents, asset group files and delivery challans - from every screen linked to this LM.</p>
      <DataTable testid="lm-all-documents-table" columns={cols} rows={rows} exportName="LM files" exportPerm="orders.export" empty="No files linked to this LM yet" />
    </section>
  );
}
